export enum SaveAsDraftVariant {
  BUTTON = 'button',
  POPUP_ITEM = 'popup-item',
}

export interface SaveAsDraftActionProps {
  variant: SaveAsDraftVariant;
}

export const SAVE_AS_DRAFT_TOOLTIP_ID = 'save-as-draft-disabled-reason-tooltip';
